// CacheKey 7d51be3374d1e2554e09ce2b8c4ddb99
//
// DO NOT MODIFY: This file was automatically generated by JsFromTranslations.
export default {
  "en-ARCH_CARE": {
    enrollment_result: {
      duplicate_call_within_interval: "Member was called or is scheduled for a call which meets the duplicate call detection period.",
      encounter_not_match: "Enrollment Failed: Member does not have an encounter that meets criteria",
      encounter_status: "Member's encounter status can not be matched.",
      invalid_phone_format: "Member's phone number format is invalid.",
      outreach_program_inactive: "The outreach program should be activated before assigning any members.",
      outreach_program_not_matched: "The member could not be enrolled in the selected program.",
      patient_blocked: "This member is blocked and cannot be called.",
      patient_deceased: "This member is marked as deceased and cannot be called.",
      patient_preference: "Member's preferred contact method is not compatible with selected program.",
      success: "The member is now enrolled in the selected program."
    },
    interaction: {
      start_error: {
        successful_voice: "The member is being called right now.",
        successful_sms: "The member is being texted right now.",
        patient_blocked: "This member is blocked and can not be called.",
        patient_deceased: "This member is marked as deceased and cannot be called."
      }
    },
    free_text_info: "Free-text questions allow to gather more information about the member as they don't have answer options.\nThey can't trigger issues so use them sparingly.",
    rounding_recent_patients_empty: "You haven't rounded any members recently.",
    rounding_instructions: "To begin, select a Rounding Program, search Admitted members (on the right panel) and click their name.",
    patient: {
      errors: {
        already_exists_with_encounter: "A member and encounter with this information already exists. Please change your information and try again or visit that existing member <a href=\"%{link}\">here</a>"
      }
    },
    disenrollment_reasons: {
      patient_blocked: "Disenrollment has been triggered because member has been blocked. Manual action from blocked members page.",
      patient_is_currently_admitted: "Disenrollment has been triggered after import because member is marked as currently admitted. We disenroll calls for encounters from inpatient units without pre admit outreach programs.",
      unschedule_from_same_outreach_program_for_call_on_date: "<i>Call On Date</i> enroller. We disenroll all member calls for same outreach program and same date but different encounters and also member calls for same outreach program, same encounter but different dates.",
      unschedule_from_same_outreach_program_for_post_admit: "<i>Post Admit</i> eroller. We disenroll all member calls for same outreach program.",
      unschedule_from_same_outreach_program_for_post_discharge: "<i>Post Discharge</i> enroller. We disenroll all member calls for same outreach program and same date but different encounters and all member calls for same outreach program but different date.",
      unschedule_from_same_outreach_program_for_pre_admit: "<i>Pre Admit</i> enroller. If there is any repeat questions we do not disenroll for same date for given outreach action if there id no repeat questions then we disenroll all member calls for same outreach program and same date but different encounters and also member calls for same outreach program, same encounter but different dates."
    }
  }
}

